import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../scss/components/section.scss';
import '../scss/components/box.scss';
import Seo from '../components/seo/Seo';
import Slider from '../components/slider';
import dataSlider from '../assets/fake-data/data-slider';
import About from '../features/about';
import Project from '../features/project';
import dataProject from '../assets/fake-data/dataProject';
import dataAbout from '../assets/fake-data/data-about';
import RoadMap from '../features/roadmap';
import dataRoadmap from '../assets/fake-data/data-roadmap';
import Work from '../features/work';
import Blog from '../features/blog';
import Partner from '../features/partner';
import dataPartner from '../assets/fake-data/data-partner';
import FAQ from '../features/faq';
import dataFaq from '../assets/fake-data/data-faq';
import Contact from './Contact';
import { alternatePath, localeFromPath } from '../lib/i18n-routes';

function HomeOne(props) {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const lang = localeFromPath(pathname);

    // Bosh sahifadagi FAQ — AI Overviews va featured snippet uchun
    const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: dataFaq.slice(0, 4).map((item) => ({
            '@type': 'Question',
            name: t(item.title),
            acceptedAnswer: { '@type': 'Answer', text: t(item.content) },
        })),
    };

    return (
        <div className='home-1'>
            <Seo
                title={t('home-meta-title')}
                description={t('home-meta-desc')}
                lang={lang}
                path={lang === 'ru' ? '/ru' : '/'}
                altPath={alternatePath(pathname, lang)}
                schema={faqSchema}
            />

            <Slider data={dataSlider} />

            <About data={dataAbout} />

            <Project data={dataProject} />

            <RoadMap data={dataRoadmap} />

            <Work />

            <Blog />

            <Partner data={dataPartner} />

            <FAQ data={dataFaq} />

            <Contact />
        </div>
    );
}

export default HomeOne;
